import { FunctionComponent } from "react"
import { ProductHighlightType } from "types"
import IconHighlightAvailability from "../../svgs/highlight-availability.svg"
import IconHighlightCompatibility from "../../svgs/highlight-compatibility.svg"
import IconHighlightMinCutLength from "../../svgs/highlight-min-cut-length.svg"
import IconHighlightRollLength from "../../svgs/highlight-roll-length.svg"
import IconHighlightRollWidth from "../../svgs/highlight-roll-width.svg"

type HighlightTypeProps = {
  type: ProductHighlightType
}

const titles = {
  availability: "Available per",
  compatibility: "Component Type",
  minCutLength: "Min. cut length",
  rollLength: "Roll length",
  rollWidth: "Roll width",
}

const icons = {
  availability: <IconHighlightAvailability />,
  compatibility: <IconHighlightCompatibility />,
  minCutLength: <IconHighlightMinCutLength />,
  rollLength: <IconHighlightRollLength />,
  rollWidth: <IconHighlightRollWidth />,
}

export const HighlightIcon: FunctionComponent<HighlightTypeProps> = ({
  type,
}) => icons[type] || null

export const HighlightTitle: FunctionComponent<
  HighlightTypeProps & { title?: string; className?: string }
> = ({ title, type, className = "" }) => (
  <p className={className}>{title || titles[type] || type}</p>
)
